import React, { useEffect, useState } from "react";
import styles from "./index.less";
import { PageWrapper } from "@/components/layout";
import { common } from "@/services/app";
import { useTranslation } from "react-i18next";
import ReactHtmlParser from "react-html-parser";
import { useSearchParams } from "react-router-dom";
import { dataUtils } from "@/utils";

const PrivacyPolicy = () => {
  const [active, setActive] = useState<string>();
  const { t, i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const queryParams = Object.fromEntries(searchParams);
  const {
    subjectCode,
    token,
    jc_language,
    jc_userAgent,
    jc_box,
    jc_appVersion,
  } = queryParams;

  // 是否来自app
  const isFromApp = () => {
    return jc_userAgent && jc_userAgent !== "undefined" ? true : false;
  };
  // 是否展示navbar
  const isShowNavBar = () => {
    return isFromApp() ? false : true;
  };

  const getArticleDetail = async () => {
    const res = await common.getArticleDetail({
      subjectCode,
    });
    setActive(res.description);
  };

  useEffect(() => {
    if (isFromApp() && jc_userAgent) {
      if (jc_language && jc_box && jc_appVersion) {
        localStorage.setItem("i18nextLng", jc_language as string);
        localStorage.setItem("fingerprint", jc_box as string);
        localStorage.setItem("userAgent", jc_userAgent as string);
        localStorage.setItem("version", jc_appVersion as string);
        i18n.changeLanguage(jc_language as string);
      } else {
        i18n.changeLanguage("en_US" as string);
      }
      if (token) {
        localStorage.setItem("token", token as string);
      }
      getArticleDetail();
    } else {
      getArticleDetail();
    }
  }, []);

  return (
    <PageWrapper title={t("me.Privacy Policy")} hasNavBar={isShowNavBar()}>
      <div className={styles.wrapper}>
        {ReactHtmlParser(active ? dataUtils.replaceMyJCK(active) : "")}
      </div>
    </PageWrapper>
  );
};

export default PrivacyPolicy;
